var U;!function(U){U.DEFAULT="DEFAULT",U.SH="SH",U.SH_PUBLIC="SH_PUBLIC",U.US="US",U.US_PUBLIC="US_PUBLIC",U.CN="CN",U.CN_PUBLIC="CN_PUBLIC",U.EU="EU",U.EU_PUBLIC="EU_PUBLIC"}(U||(U={}));export{U as Region};
